import { Quote } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

// No fake reviews. Section is ready to be populated with real testimonials.
const testimonials = [];

export default function Testimonials() {
  return (
    <section className="bg-mist py-24 lg:py-32" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="Testimonials"
          title="What Our Clients Say"
          subtitle="Real experiences from hospitality businesses we support."
        />

        {testimonials.length === 0 ? (
          <Reveal className="mx-auto mt-14 max-w-2xl">
            <div className="flex flex-col items-center rounded-3xl border border-dashed border-line bg-white px-8 py-16 text-center">
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-sky/15 text-ocean">
                <Quote className="h-6 w-6" />
              </span>
              <p className="mt-6 font-serif text-2xl text-navy">Client testimonials coming soon.</p>
              <p className="mt-3 text-sm text-slate-600">
                We're building relationships with hospitality businesses across Pakistan. Real stories will appear here soon.
              </p>
            </div>
          </Reveal>
        ) : (
          <div className="mt-14 grid gap-6 md:grid-cols-3" />
        )}
      </div>
    </section>
  );
}
